const state = {
  mobileTelecoms: {},
  mobileCategory: {},
  mobileDevice: {},
  mobileDeviceDetail: {},
  mobilePlanCategory: {},
  mobilePlans: {},
  mobilePlanDetail: {},
  mobileRequestListIng: {},
  mobileRequestListEnd: {},
  mobileRequestView: {},
  mobileEstimateList: {},
  mobileEstimateGroupList: {},
  mobileEstimateDetail: {},
  mobileServiceList: {},
  mobilePromise: {},
  mobilePromiseList: {},
  mobileEstimatePreivew: {},
  mobileEstimateNewCnt: 0,
  mobilePromiseNewCnt: 0,
  mobileApplyNewCnt: 0,
  mobileInsuranceList: {},
  mobileChatEstimateList: {},
};

export default state;
